export const rlAuxiliaryAnalysisKeys = {
  generalInfo: hash => ["rl_auxiliary_analysis_general_info", hash],
  fileTree: hash => ["file_tree", hash],
  heuristics: hash => ["heuristics", hash],
  // TCAI-0106 returns this as "service_results" but we call this Plugin Results
  pluginResults: hash => ["service_results", hash],
  tags: hash => ["tags", hash],
  extractedFiles: (hash, params) => [
    "rl_auxiliary_analysis_extracted_files",
    hash,
    params
  ],
  extractedFilesAll: hash => ["rl_auxiliary_analysis_extracted_files", hash],
  extractedFilesFilterOptions: hash => [
    "rl_auxiliary_analysis_extracted_files_filter_options",
    hash
  ],
  displayStatus: hash => ["rl_auxiliary_analysis_display_status", hash],
  displayStatusAll: () => ["rl_auxiliary_analysis_display_status"],
  showLinks: hash => ["rl_auxiliary_analysis_show_links", hash]
};
